<template>
    <section>
        <Divider />
        <div class="block text-[1] md:text-[1.063rem] 3xl:text-[1.125rem] text-black font-bold mt-4 md:mt-5 lg:mt-6 xl:mt-7 mb-2">{{
        $t('user.related_products') }}</div>
        <div :class="`relative mt-4 show-arrow-when-hover`">
        <TransitionGroup name="products-list" tag="ul" id="productsItemsList"
          :class="`${isLoading ? 'disabled' : ''} products-items-list`">
          <li v-for="item in list" :key="item.id">
            <ProductItem 
              :item="item" 
              :favoriteProductsIDs="favoriteProductsIDs" 
              :withAds="true"
              :enableColorExtraction="true"
            />
          </li>
        </TransitionGroup>
        
        <!-- More Products Button -->
        <div class="flex justify-center mt-6">
          <button 
            class="px-6 py-2.5 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors duration-300 font-medium shadow-sm hover:shadow-md flex items-center gap-2"
            @click="formatCategoryLink(productData.category.id, productData.sub_category?.id)">
            {{ $t('user.more_products') }}
          </button>
        </div>
      </div>
    </section>
</template>

<script>
import Divider from "./Divider";
import ProductItem from "../productItemDesigns/ProductItem.vue";
import { useGlobalStore } from '@/store/Modules/global';
import { mapState } from 'pinia';
import { ROUTESNAMES } from '@/helpers';
export default {
    props: {
        list: {
            type: Array,
            required: true,
            default: () => ([])
        },
        isLoading: {
            type: Boolean,
            required: true,
            default: false
        },
        productData: {
            type: Object,
            required: true,
            default: () => ({})
        },
    },
    components: {
        Divider,
        ProductItem
    },
    computed:{
      ...mapState(useGlobalStore, {
        favoriteProductsIDs: (store) => store?.getFavoriteProducts || [],
      }),
    },
    methods: {
        formatCategoryLink(mainCategoryId, subCategoryId) {
          // Build query parameters for filtering
          let queryToUrl = '';
          
          // Check if it's a sub-category or main category
          if (subCategoryId) {
            // It's a sub-category
            queryToUrl = `main_category_id=${mainCategoryId}&category_id=${subCategoryId}`;
          } else if (mainCategoryId) {
            // It's a main category
            queryToUrl = `main_category_id=${mainCategoryId}`;
          }

          // Add from parameter
          queryToUrl += `&from=list`;
          
          // Encode the query parameters
          let encodedQuery = btoa(encodeURIComponent(queryToUrl));
          
          // Navigate to products page with encoded query
          return this.$router.push(`${ROUTESNAMES.user.products}?${encodedQuery}`).then(() => {
            this.$router.go(0); // Refresh the page to ensure filter state is updated
          });
        },
    }
}
</script>

<style>

</style>